import axios from "axios";
import { useEffect, useState } from "react"
import useLoading from "./useLoading";

const useExpirationDate = () => {
    const [expired, setExpired] = useState(false);
    const { isLoading, end, start } = useLoading({ defaultLoading: true });

    const { REACT_APP_EXP_DATE: EXP_DATE, REACT_APP_LOCAL_SERVER } = process.env;
    const expirationDate = new Date(EXP_DATE || "2025-07-01T00:00:00Z");

    useEffect(() => {
        start();
        axios.post(`${REACT_APP_LOCAL_SERVER}/auth/exp-check`, { expirationDate })
            .then(res => {
                return setExpired(res.data.expired)
            })
            .catch(() => {
                return setExpired(true) // mejor bloquear si hay error
            })
            .finally(() => end());
    }, []);

    return {
        expired,
        isLoading
    }
}

export default useExpirationDate